module.exports = __webpack_public_path__ + "img/sage-1.b83ad1ec.jpg";